// extracted by mini-css-extract-plugin
export default {"tinyLine":"EmotionLine_tinyLine__HzW1z"};